import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { NavLink } from "react-router-dom";
import { logout } from "../../Stores/Action/AuthAction";
import { modena_logo_putih } from "../../Images";
import modena_logo_hitam from "../../Images/modena-logo-hitam.png";
import { elipse_user, profile } from "../../Images";
import { useNavigate } from "react-router-dom";
import { InputSwitch } from "primereact/inputswitch";
import { toggleMode } from "../../Stores/Action/ThemeAction";
import { getHierarchy } from "../../Services/MenuService";
import { setSearchValue } from "../../Stores/Action/AppAction";
import { setDefaultPage } from "../../Stores/Action/PaginateAction";
//import { iteratorSymbol } from 'immer/dist/internal';

const { $ } = window;

const branding = [
  { id: 1, text: "BSM", url: "" },
  { id: 2, text: "Logo", url: "" },
  { id: 3, text: "Super Graphic", url: "" },
  { id: 4, text: "Corporate Assets", url: "" },
  { id: 5, text: "Icons", url: "" },
  { id: 6, text: "Fonts", url: "" },
];

const multiMedia = [
  { id: 1, text: "Product", url: "" },
  { id: 2, text: "Context", url: "" },
];

const campaign = [
  { id: 1, text: "On-Going", url: "" },
  { id: 2, text: "Up-Coming", url: "" },
  { id: 3, text: "Past", url: "" },
];

const event = [
  { id: 1, text: "Photo", url: "" },
  { id: 2, text: "Video", url: "" },
];

const Navbar = () => {
  const navigate = useNavigate();
  let { userInfo } = useSelector((state) => state.auth);

  if (!userInfo) {
    userInfo = {};
  }

  const dispatch = useDispatch();

  const [state, setState] = useState({
    menus: [],
  });

  const onExploreClick = (param) => {
    dispatch(setDefaultPage(1));

    dispatch(setSearchValue(param));
    navigate("/asset/search");
  };

  const signOut = () => {
    dispatch(logout(navigate));
  };

  useEffect(() => {
    const requests = [getHierarchy({ perpage: 100, filterAnd: `menu_level:1,is_active:true` }).then((res) => res.data)];
    Promise.all(requests).then((results) => {
      const [_menus] = results;
      //console.log('_menus', _menus.data);
      setState({ ...state, menus: _menus.data });
    });
  }, []);

  const { menus } = state;
  return (
    <nav className="navbar navbar-expand-lg" id="mainNav">
      <div className="container" style={{ paddingTop: 10 }}>
        <NavLink to="/" className="navbar-brand">
          <img src={modena_logo_hitam} className="mobile_format blck_logo"></img>
        </NavLink>
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarResponsive"
          aria-controls="navbarResponsive"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <i className="fas fa-bars" />
        </button>
        <div className="collapse navbar-collapse" id="navbarResponsive">
          <NavLink to="/" className="navbar-brand">
            <img src={modena_logo_putih} className="webview_format"></img>
          </NavLink>
          <div className="wrap_all_menu">
            <nav className="navbar navbar-expand-lg">
              <div className="container-fluid">
                <div className="collapse navbar-collapse" id="navbarSupportedContent">
                  <ul className="navbar-nav mx-auto mb-2 mb-lg-0">
                    {menus.map((item, i) => (
                      <li key={i.toString()} className="nav-item dropdown" style={{ width: 140, position: "relative" }}>
                        <a
                          className="nav-link px-lg-0"
                          href="#"
                          role="button"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                          style={{ textAlign: `center`, fontFamily: "Inter", fontSize: 14, fontWeight: 100 }}
                        >
                          {item.menu_name}
                        </a>
                        <ul className="dropdown-menu">
                          {item.hierarchy &&
                            item.hierarchy.map(
                              (detail) =>
                                detail.is_active && (
                                  <li key={detail.menu_code}>
                                    <a
                                      className="dropdown-item non-underline-link"
                                      href="#"
                                      onClick={() => onExploreClick(detail.menu_name)}
                                      style={{ fontFamily: "Inter", fontSize: 13, fontWeight: 100 }}
                                    >
                                      {detail.menu_name}
                                    </a>
                                  </li>
                                )
                            )}
                        </ul>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </nav>
          </div>
          <div className="dropdown">
            <ul className="navbar-nav mx-auto mb-2 mb-lg-0 menu_mobile">
              {menus.map((item, i) => (
                <li key={i.toString()} className="nav-item dropdown list_menu">
                  <a className="nav-link px-lg-0" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false" style={{ fontFamily: "Inter", fontSize: 14, fontWeight: 100, marginLeft: 30 }}>
                    {item.menu_name}
                  </a>
                  <ul className="dropdown-menu">
                    {item.hierarchy &&
                      item.hierarchy.map(
                        (detail) =>
                          detail.is_active && (
                            <li key={detail.menu_code}>
                              <a className="dropdown-item non-underline-link" href="#" onClick={() => onExploreClick(detail.menu_name)} style={{ fontFamily: "Inter", fontSize: 13, fontWeight: 100 }}>
                                {detail.menu_name}
                              </a>
                            </li>
                          )
                      )}
                  </ul>
                </li>
              ))}
            </ul>

            <button className="btn profile_menu_mobile" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
              <img src={userInfo.avatar != "" ? process.env.REACT_APP_OBS_URL + userInfo.avatar : profile} style={{ width: 55, height: 55, borderRadius: `50%`, border: `1px solid #ffff` }}></img>
              <div className="name_dropdown">{userInfo.fullname}</div>
            </button>
            <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
              <li>
                <NavLink className="dropdown-item" to="/favorite">
                  My Favorite
                </NavLink>
              </li>
              <li>
                <hr className="dropdown-divider" />
              </li>
              {userInfo.role_id == 1 && (
                <div>
                  <li>
                    <NavLink className="dropdown-item" to="/asset">
                      Upload
                    </NavLink>
                  </li>
                  <li>
                    <NavLink className="dropdown-item" to="/asset-batch">
                      Batch Upload
                    </NavLink>
                  </li>
                  <li>
                    <hr className="dropdown-divider" />
                  </li>
                  <li>
                    <NavLink className="dropdown-item" to="/setting">
                      Settings
                    </NavLink>
                  </li>
                  <li>
                    <hr className="dropdown-divider" />
                  </li>
                </div>
              )}
              <li>
                <a className="dropdown-item" href="#" onClick={signOut}>
                  Logout
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
